<template>
  <div class="nav-box flex-c-c">
    <search-menu class="right-menu-item"></search-menu>
    <screenfull id="screenfull" class="right-menu-item hover-effect" />
    <el-dropdown @command="handleCommand" placement="top" class="avatar-box">
      <div>
        <img class="avatar" :src="mixinUserInfo?.avatar ? (mixinFileServer + mixinUserInfo.avatar) : '@/assets/logo.png'" alt="">
        <span class="user-name">{{ mixinUserInfo?.userName }}</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout" class="flex-c-s">
          <svg-icon iconClass="logout"></svg-icon>
          <span style="margin-left: 12px;">退出登录</span>
        </el-dropdown-item>
        <el-dropdown-item command="editUserInfo" class="flex-c-s">
          <svg-icon iconClass="user-manage"></svg-icon>
          <span style="margin-left: 12px;">编辑信息</span>
        </el-dropdown-item>
        <el-dropdown-item command="editPassword" class="flex-c-s">
          <svg-icon iconClass="setting"></svg-icon>
          <span style="margin-left: 12px;">修改密码</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <edit-user-info    
      ref="editUserInfo"
      title="编辑信息"
      width="666px"
      :visible.sync="showEditUser"
      @close="showEditUser = false"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"></edit-user-info>

      <edit-password
        ref="editPassword"
        title="修改密码"
        width="666px"
        :visible.sync="showEditPassword"
        @close="showEditPassword = false"
        :modal-append-to-body="true"
        :append-to-body="true"
        :close-on-click-modal="false"></edit-password>
  </div>
</template>

<script>
import SearchMenu from "@/components/search-menu"
import Screenfull from "@/components/screenfull"
import EditUserInfo from "@/components/edit-user-info/inedx"
import EditPassword from "@/components/edit-password/inedx"
export default {
  components: {
    SearchMenu,
    Screenfull,
    EditUserInfo,
    EditPassword
  },
  data() {
    return {
      showEditUser: false,
      showEditPassword: false
    }
  },
  watch: {
    showEditUser(val) {
      this.$nextTick(() => {
        this.$refs.editUserInfo.resetDialogForm()
      })
    },
    showEditPassword(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$refs.editPassword.resetDialogForm()
        })
      } 
    }
  },
  methods: {
    handleCommand(val) {
      this[val]()
    },
    // 注销
    logout() {
      this.$modal.alertWarning("确认退出登录？").then(() => {
        this.$store.dispatch("user/logout").then(() => {
          this.$modal.msgSuccess("退出登录成功")
          this.$router.push(`/login`)
        })
      })
    },
    // 点击弹出编辑用户信息弹框
    editUserInfo() {
      this.showEditUser = true
    },
    // 重置密码
    editPassword() {
      this.showEditPassword = true
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-box {
  height: 100%;
  .right-menu-item {
    margin-right: 20px;
    color: #fff;
    cursor: pointer;
  }
  .avatar-box {
    .avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      vertical-align: middle;
    }
    .user-name{
      color: #fff;
      font-size: 16px;
      padding: 0 12px;
    }
  }
}
</style>